<!-- 企业上云 -->
<template>
  <div class="cloud">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <!-- 方案简介 -->
    <Introduction :title="propsCon.title" :content="propsCon.content" :image="propsCon.img"></Introduction>
    <!-- 应用场景 -->
    <div class="appScene">
      <h3 class="h3">应用场景</h3>
      <div class="listItem width">
        <div class="listItemL" v-for="(item,i) in modelList" :key="i">
          <h4>{{item.title}}</h4>
          <div class="pp">
            <p v-for="(item1, i1) in item.content" :key="i1">{{item1}}</p>
          </div>
          <img :src="item.img" alt srcset />
        </div>
      </div>
    </div>
    <!-- 系统架构 -->
    <TitleImg :title="titleImg.title" :image="titleImg.img"></TitleImg>
    <!-- 直观效应 -->
    <div class="oneList">
      <h3 class="h3">直观效应</h3>
      <div class="oneCon width">
        <div class="listItem" v-for="(item,i) in oneList" :key="i">
          <h4>{{item.title}}</h4>
          <p>{{item.p}}</p>
        </div>
      </div>
    </div>
    <!-- 提交方案咨询 -->
    <div class="subPlay">
      <el-button type="primary" icon="el-icon-s-order">提交方案咨询</el-button>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Introduction from '../components/Introduction'
import TitleImg from '../components/TitleImg'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Introduction, TitleImg, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '企业上云解决方案',
        bgImg: require('../assets/images/u1633.png'),
        content: '推动业务流、人才流、资金流等的在线化、网络化、智能化发展',
        bl: true,
      },
      propsCon: {
        title: '方案简介',
        content: [
          '企业上云是指企业通过网络,将企业的基础设施、管理及业务部署到云端，利用网络便捷地获取云服务商提供的计算、存储、软件、数据服务，以此提高资源配置效率、降低信息化建设成本、促进共享经济发展、加快新旧动能转换。本方案将协助企业进行基础上云，数据上云，设备上云，系统上云实施。 以及跨国家、跨地域、跨行业、跨企业的全球信息互联互通能力，是整个工业互联网网络实现互联互通的关键基础设施。主要由三要素组成：一是标识，这就相当于机器、物品的“身份证”；二是标识服务，即利用标识，对机器和物品进行唯一性的定位和信息查询，是实现全球供应链系统和企业生产系统的精准对接、产品的全生命周期管理和智能化服务的前提和基础；三是标识管理，即通过国家工业互联网标识解析体系，实现标识的申请、注册、分配、备案，为机器、物品分配唯一的编码。',
        ],
        img: require('../assets/images/u1640_mouseOver.svg'),
      },
      modelList: [
        {
          title: '企业基础设施上云',
          content: [
            '一是计算资源上云；',
            '二是存储资源上云；',
            '三是网络资源上云；',
            '四是安全防护上云；',
            '五是办公桌面上云；',
          ],

          img: require('../assets/images/u1650.png'),
        },
        {
          title: '企业平台系统上云',
          content: [
            '一是数据库平台上云；',
            '二是大数据分析平台上云；',
            '三是物联网平台上云；',
            '四是软件开发品台上云；',
            '五是电商平台上云。',
          ],
          img: require('../assets/images/u1651.png'),
        },
        {
          title: '企业业务应用上云',
          content: [
            '一是协同办公应用上云；',
            '二是经营管理应用上云；',
            '三是运营管理应用上云；',
            '四是研发设计上云；',
            '五是其他应用上云。',
          ],
          img: require('../assets/images/u1652.png'),
        },
      ],
      titleImg: {
        title: '系统架构',
        img: require('../assets/images/u1659.png'),
      },
      oneList: [
        {
          title: '系统架构',
          p:
            '企业上云能够降低企业的技术开发成本，大多数中小企业并没有庞大的IT预算开支，处理技术采购方面问题的精力也相当有限。我们需要将有限的资金用到真正需要的方面。这也中小企业的共同点。使用云计算服务比购买一般的物理硬件要便宜得多，那么中小企业就可以摆脱很多不必要的开支。',
        },
        {
          title: '系统架构',
          p:
            '企业上云能够降低企业的技术开发成本，大多数中小企业并没有庞大的IT预算开支，处理技术采购方面问题的精力也相当有限。我们需要将有限的资金用到真正需要的方面。这也中小企业的共同点。使用云计算服务比购买一般的物理硬件要便宜得多，那么中小企业就可以摆脱很多不必要的开支。',
        },
        {
          title: '系统架构',
          p:
            '企业上云能够降低企业的技术开发成本，大多数中小企业并没有庞大的IT预算开支，处理技术采购方面问题的精力也相当有限。我们需要将有限的资金用到真正需要的方面。这也中小企业的共同点。使用云计算服务比购买一般的物理硬件要便宜得多，那么中小企业就可以摆脱很多不必要的开支。',
        },
        {
          title: '系统架构',
          p:
            '企业上云能够降低企业的技术开发成本，大多数中小企业并没有庞大的IT预算开支，处理技术采购方面问题的精力也相当有限。我们需要将有限的资金用到真正需要的方面。这也中小企业的共同点。使用云计算服务比购买一般的物理硬件要便宜得多，那么中小企业就可以摆脱很多不必要的开支。',
        },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.appScene {
  background: url('../assets/images/u1644.jpg') no-repeat;
  background-size: cover;
  padding-top: 20px;
  margin-bottom: 10px;
  padding-bottom: 20px;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #fff;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .listItem {
    display: flex;
    .listItemL {
      flex: 1;
      margin: 0 10px;
      background-color: rgba(13, 16, 45, 1);

      h4 {
        color: #fff;
        text-align: center;
      }
      .pp {
        color: #fff;
        padding: 0 20px;
        margin-bottom: 10px;

        p {
          margin: 0;
          line-height: 20px;
        }
      }
      img {
        display: block;
        width: 100%;
        height: 300px;
      }
    }
    .listItemL:first-child {
      background-color: rgba(4, 121, 175, 1);
    }
    .listItemL:last-child {
      background-color: rgba(22, 22, 24, 1);
    }
  }
}
.oneList {
  background: url('../assets/images/u111_div.png') no-repeat;
  background-size: cover;
  padding-top: 20px;
  margin-bottom: 10px;
  padding-bottom: 20px;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #fff;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .oneCon {
    display: flex;
    padding: 60px 0;
    .listItem {
      flex: 1;
      margin: 0 10px;
      background-color: rgba(242, 242, 242, 1);
      border-radius: 4px;
      h4 {
        text-align: center;
      }
      p {
        padding: 0 20px 20px 20px;
        text-indent: 2em;
        line-height: 18px;
      }
    }
  }
}
.subPlay {
  text-align: center;
  padding: 60px 0;
  background-color: #fff;
}
</style>
